import { Button, Progress } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeProgressBar } from "redux/store/download/action";
import { InfoCircleOutlined } from "@ant-design/icons";

const ScreenRecordingDownloadProgress = () => {
  const dispatch = useDispatch();

  const { progressList, visible, ajaxRequest } = useSelector(
    /// @ts-ignore
    (state) => state.screenshot
  );

  //   const onCancel = () => {
  //     if (ajaxRequest) {
  //       ajaxRequest.cancel();
  //     }

  //     dispatch(closeProgressBar());
  //   };

  if (!visible) return null;

  return (
    <div
      className="fixed right-8 bottom-20 rounded-lg z-[9999] bg-white px-6 py-4 border-teal-500 w-96"
      style={{
        boxShadow:
          "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
      }}
    >
      <h3 className="text-sm font-semibold mb-2">Downloading Recordings</h3>
      <div className="space-y-3 max-h-60 overflow-y-auto">
        {progressList.map(({ id, filename, percent }) => (
          <div key={id}>
            <p className="text-xs truncate">{filename}</p>
            <div className="w-full bg-gray-700 h-2 rounded-full mt-1">
              <div
                className={`h-2 rounded-full transition-all duration-200 ${
                  percent === 100 ? "bg-green-500" : "bg-green-400"
                }`}
                style={{ width: `${percent}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScreenRecordingDownloadProgress;
